import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { VueHttpClientFactoryService } from '@vue/vueframework';
import { Observable, of } from 'rxjs';
import { AppDefaultsService } from '../../app-defaults.service';
import { CASUserRole } from '../types/cas-user-role.model';
import { CASUserSearchResult } from '../types/cas-user-search-result.model';

@Injectable({
  providedIn: 'root'
})
export class CasService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  public constructor(
    private vueHttpClientFactoryService: VueHttpClientFactoryService,
    private vueAppDefaultsService: AppDefaultsService
  ) {
  }

  /**
   * Get the users associated to the given site
   *
   * @param userId
   *    Id of CAS User to get roles for.
   *
   *  @return
   *    UserRoleResponse object with roles for user.
   */
  public getUserRoles(userId: number): Observable<CASUserRole[]> {
    if (userId) {
      const url = this.vueAppDefaultsService.getCASRESTRoot() +
        '/rest/realms/TESTCENTER/users/' + userId.toString() + '/roles';
      return this.vueHttpClientFactoryService.getVueHttpClient().get(url, this.httpOptions);
    }
    return of([]);
  }

  /**
   *  Retrieve all enabled (i.e. active) users for the provided siteId.
   *
   *  @param siteId
   *    The ID of the site for which to retrieve users.
   *
   *  @return
   *    Potentially empty list of users as search results.
   */
  public findUsersForSite(siteId: number): Observable<CASUserSearchResult[]> {
    const url = this.vueAppDefaultsService.getCASRESTRoot() +
      '/rest/realms/TESTCENTER/users/searchUsers?enabled=true&scopeId=' + siteId.toString();

    return this.vueHttpClientFactoryService.getVueHttpClient().get(
      url,
      this.httpOptions
    );
  }
}
